import { render, staticRenderFns } from "./ReportFollowups.vue?vue&type=template&id=0b4e47a6&scoped=true&"
import script from "./ReportFollowups.vue?vue&type=script&lang=js&"
export * from "./ReportFollowups.vue?vue&type=script&lang=js&"
import style0 from "./ReportFollowups.vue?vue&type=style&index=0&id=0b4e47a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4e47a6",
  null
  
)

export default component.exports